import { Link } from 'react-router-dom'
import { Sparkles, ArrowLeft, Shield, Database, Eye, Cookie, Mail, Trash2, Lock } from 'lucide-react'
import { useAuthStore } from '../store/authStore'

export default function Privacy() {
  const { user } = useAuthStore()
  return (
    <div>

      <div className="max-w-3xl mx-auto px-4 pt-4 pb-8">
        {/* Header */}
        <div className="flex items-center gap-3 mb-8">
          <Link
            to="/"
            className="p-2 rounded-xl glass-hover text-gray-400 hover:text-white transition-all"
          >
            <ArrowLeft className="w-5 h-5" />
          </Link>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
              <Sparkles className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold gradient-text">Политика конфиденциальности</h1>
              <p className="text-xs text-gray-500">Последнее обновление: 18 июня 2026 г.</p>
            </div>
          </div>
        </div>

        <div className="glass-card p-6 md:p-8 space-y-6 text-sm text-gray-300 leading-relaxed">
          <div className="bg-sky-500/5 border border-sky-500/20 rounded-xl p-4 text-sky-300 text-xs">
            <div className="flex items-start gap-3">
              <Shield className="w-4 h-4 mt-0.5 shrink-0" />
              <div>
                <strong>Ваши данные под защитой.</strong>
                {' '}Мы собираем минимально необходимую информацию для работы сервиса.
                Никакие данные не передаются третьим лицам, кроме AI-провайдеров
                для выполнения генераций.
              </div>
            </div>
          </div>

          <Section icon={<Database className="w-5 h-5" />} title="1. Какие данные мы собираем">
            <p>1.1. При регистрации и использовании Сайта мы можем собирать:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Email и имя</strong> — для создания аккаунта и связи с вами;</li>
              <li><strong>Пароль</strong> — хранится в зашифрованном виде (bcrypt);</li>
              <li><strong>Аватар</strong> — если вы его загружаете;</li>
              <li><strong>История запросов</strong> — чаты, сгенерированные изображения, музыка, видео;</li>
              <li><strong>Техническая информация</strong> — IP-адрес, user-agent, данные об устройстве;</li>
              <li><strong>Cookie</strong> — для поддержания сессии и аналитики.</li>
            </ul>
            <p>1.2. Мы не собираем, не храним и не обрабатываем:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Паспортные данные;</li>
              <li>Платёжные данные (номера карт, CVV) — все платежи обрабатываются платёжными партнёрами;</li>
              <li>Геолокацию (кроме IP-адреса);</li>
              <li>Биометрические данные.</li>
            </ul>
          </Section>

          <Section icon={<Eye className="w-5 h-5" />} title="2. Как мы используем ваши данные">
            <p>2.1. Ваши данные используются исключительно для:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Обеспечения работы Сайта (аутентификация, генерация контента);</li>
              <li>Улучшения качества сервиса;</li>
              <li>Технической поддержки;</li>
              <li>Отправки уведомлений (по запросу);</li>
              <li>Соблюдения требований законодательства РФ.</li>
            </ul>
            <p>2.2. Контент, который вы генерируете (тексты, изображения, видео, музыка),
            передаётся AI-провайдерам (Together.ai, Fal.ai, OpenRouter и др.)
            исключительно для выполнения генерации. Мы не передаём провайдерам
            ваши персональные данные.</p>
            <div className="mt-2 p-3 rounded-lg bg-amber-500/5 border border-amber-500/20 text-amber-300 text-xs">
              <strong>Важно:</strong> Пользователь предупреждён и соглашается с тем, что
              промпты и иные материалы, добровольно вводимые им в поля генерации, не должны
              содержать персональные данные (свои или третьих лиц). Вводя такие данные,
              Пользователь делает это на свой страх и риск, выражая согласие на их обработку
              и трансграничную передачу соответствующим AI-провайдерам для исполнения запроса.
              Администрация не проверяет содержание промптов на наличие ПДн и не несёт
              ответственности за их распространение.
            </div>
          </Section>

          <Section icon={<Lock className="w-5 h-5" />} title="3. Хранение и защита данных">
            <p>3.1. Данные хранятся на серверах, расположенных на территории
            Российской Федерации и/или стран ЕАЭС.</p>
            <p>3.2. Мы применяем организационные и технические меры для защиты
            ваших данных: шифрование (SSL/TLS), хеширование паролей (bcrypt),
            защита API-ключей (AES-256), межсетевые экраны.</p>
            <p>3.3. Срок хранения данных — на время существования аккаунта.
            После удаления аккаунта данные удаляются в течение 30 дней,
            за исключением случаев, когда их хранение требуется по закону.</p>
          </Section>

          <Section icon={<Cookie className="w-5 h-5" />} title="4. Cookie и аналитика">
            <p>4.1. Сайт использует cookie для:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Поддержания сессии пользователя (remember me);</li>
              <li>Сбора анонимной статистики использования (Яндекс.Метрика);</li>
              <li>Предотвращения злоупотреблений (rate limiting).</li>
            </ul>
            <p>4.2. Вы можете отключить cookie в настройках браузера.
            Это может повлиять на работу некоторых функций Сайта.</p>
          </Section>

          <Section icon={<Mail className="w-5 h-5" />} title="5. Коммуникация">
            <p>5.1. Мы отправляем вам письма только:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>С подтверждением email (при регистрации);</li>
              <li>С приветствием (после подтверждения);</li>
              <li>По вашему запросу (восстановление доступа).</li>
            </ul>
            <p>5.2. Мы не рассылаем рекламные и маркетинговые письма без вашего
            отдельного согласия.</p>
          </Section>

          <Section icon={<Trash2 className="w-5 h-5" />} title="6. Ваши права">
            <p>6.1. В соответствии с Федеральным законом № 152-ФЗ «О персональных данных»
            вы имеете право:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Получить информацию об обработке ваших данных;</li>
              <li>Требовать уточнения, блокирования или уничтожения ваших данных;</li>
              <li>Отозвать согласие на обработку персональных данных;</li>
              <li>Потребовать удаление аккаунта и всех связанных данных.</li>
            </ul>
            <p>6.2. Для реализации своих прав обратитесь в поддержку:
            <a href="mailto:support@chat-neuro.ru" className="text-indigo-400 hover:text-indigo-300 ml-1">
            support@chat-neuro.ru</a>.</p>
          </Section>

          <Section icon={<Shield className="w-5 h-5" />} title="7. Изменения политики">
            <p>7.1. Администрация вправе обновлять Политику конфиденциальности.
            Новая версия вступает в силу с момента публикации на Сайте.</p>
            <p>7.2. Рекомендуем периодически проверять эту страницу на предмет изменений.</p>
          </Section>
        </div>
      </div>


    </div>
  )
}

function Section({ icon, title, children }: { icon: React.ReactNode; title: string; children: React.ReactNode }) {
  return (
    <div className="space-y-3">
      <h2 className="text-base font-bold text-white flex items-center gap-2">
        <span className="text-sky-400">{icon}</span>
        {title}
      </h2>
      <div className="space-y-2">{children}</div>
    </div>
  )
}
